<template>
	<div class="app-wrapper">
		<div class="bg-top"></div>
		<el-container>
			<sidebar ref="sidebar" v-if="show"></sidebar>
			<el-container :style="{paddingLeft:show?'256px':'0'}">
				<el-main>
					<navbar ref="navbar"></navbar>
					<router-view v-wechat-title="$route.meta.title" />
					<div class="copy-right">&copy;2009- <span>{{ year }}</span>.健生来康(北京)科技有限公司.All Rights Reserved.</div>
				</el-main>
			</el-container>
			
		</el-container>			
	</div>

</template>

<script>
import {Sidebar, Navbar} from './components';
import api from '@/service/api.js';
import { EventBus } from '@/event-bus.js';
import telMixins from './components/Navbar/telMixins'; 

export default {
  name: 'App',
  components: {Sidebar, Navbar},
	mixins: [telMixins],

	data(){
		return {
			show:true,
			year:2023,
			hospitalVersion:'4.3.4-dev',
			user:{},
			hospitalCode:'YS_HM4',
			GXcallFlag:false,
			UboxCallFlag:false,
			menuData:[],
			route_new:''

		}
	},
	async created(){
		this.getFullYar();
		this.hospitalCode=await api.getHospitalCode();
		this.GXcallFlag=await api.getGXcallFlag();
		this.UboxCallFlag=await api.getUboxCallFlag();
		console.log(this.hospitalCode,'--冠讯',this.GXcallFlag,'----ubox',this.UboxCallFlag);
		// this.$watch(
		// 		() => window.location.hash, // 监听的对象是 $route.query
		// 		(newQuery, oldQuery) => {
		// 			this.routeHandle()
		// 		}
		// 	);
		// 	this.routeHandle()
	},
	mounted(){
		document.addEventListener('visibilitychange', this.handleVisiable);
		// EventBus.$on('update-callstatus',(newVal)=>{
		// 	this.$refs['navbar'].update();
		// });

	},
	methods: {
		
			traverse(items,targetUrl) {
				items.forEach(item => {
					if (item.data.menuUrl.toLowerCase().trim() == targetUrl) {
						this.menuData.push(item);
					}
					if (item.children && item.children.length > 0) {
						this.traverse(item.children,this.route_new);
						// console.log(item.children,'=========cc');
					}
				});
			},

		handleVisiable(e){
			this.user = JSON.parse(localStorage.getItem('user')).data;
			if(this.user.user.roleId !='4'&&this.user.user.roleId !='6') return false;
			if(this.GXcallFlag){
				if(e.target.visibilityState == "visible"){
					let s=JSON.parse(localStorage.getItem('callstatus'))
					EventBus.$emit('update-callstatus',s)
					this.$refs['navbar'].update();
				}
				let callState=localStorage.getItem('callState');
				if(!callState){
					// 关闭新开页面，回到列表页，刷新列表数据
					if(e.target.visibilityState == "visible"){
						this.callInit();
					} else {
						this.DisConnect();
					}
				}
			} else if(this.UboxCallFlag) {// if(this.hospitalCode=='YS_HM4')
				if(e.target.visibilityState == "visible"){
					this.$refs['navbar'].update();
				}
				let callState=localStorage.getItem('callState');
				if(!callState){
					if(e.target.visibilityState == "visible"){
						// window.uboxInit();
						window.uboxInit(this.callBack,this.callerHandle,this.statusHandle);//电话盒子呼叫
						// this.callInit();//冠讯呼叫
					} else {
						this.DisConnect();
						console.log('隐藏');
					}
				}
			}			
		},
		updateSidebar() {
			this.$refs['sidebar'].update();
			this.show = this.$route.name == 'Patient/User' ? false :true;
		},
		async getFullYar(){
			this.year= new Date().getFullYear();
			this.hospitalVersion = await api.getHospitalVersion();
			console.log(this.hospitalVersion);
		}
	}
}
</script>

<style lang="less" scoped>
.bg-top {
	position: absolute;
	width: 100%;
	height: 180px;
	min-width: 1300px;
	&::before{
		position: absolute;
		width: 100%;
		height: 60px;
		background: #6a9ce3;
		content: '';
	}	
	&::after {
		position: absolute;
		top: 60px;
		width: 100%;
		height: 120px;
		background: #699ce4;
		box-shadow: 0 0 30px 15px #5a8fdd inset;
		content: '';
	}
}

.app-wrapper {
	>.el-container {
		// position: relative;
		width: 100%;
		// max-width: 1300px;
		min-width: 1300px;
		min-height: 100vh;
		margin: auto;
		// z-index: 1;
		
		>.el-aside {
			height: 100vh;
			background: #fff;
		}
		>.el-container {
			position: relative;
			padding-left: 220px;
			>.el-main {
				padding: 0  10px;
				overflow: hidden;
			}
		}
	}
}	
</style>
